import * as React from "react";
import { singleton } from "logic/singleton";
const defaultContext = {
  getExplainForWidget: () => void 0,
  explainedSearch: void 0
};
const SearchExplainContext = React.createContext(defaultContext);
export default singleton("contexts.SearchExplain", () => SearchExplainContext);
